var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 41,
    viewBox: "0 0 79 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0333 0C17.4503 0 0 18.2619 0 40.8488H78.0666C78.0666 18.2619 60.5016 0 39.0333 0Z",
    fill: "#1264E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6541 22.0628V19.0593H14.7205V16.1758L17.9349 14.2536V19.0593H20.1162V22.0628H17.9349V26.0276C17.9349 26.9888 18.0498 27.5895 18.2794 27.8298C18.509 28.0701 19.1979 28.1901 20.1162 28.1901V31.4341H19.657C17.8202 31.4341 16.4425 31.0737 15.7537 30.2326C15.065 29.3916 14.6057 28.0701 14.6057 26.0276V22.0628H12.6541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3673 29.7517C30.2194 30.9532 28.7268 31.6741 27.0048 31.6741C25.2827 31.6741 23.7903 31.0733 22.6424 29.7517C21.4943 28.5502 20.8054 26.9884 20.8054 25.1862C20.8054 23.3841 21.3794 21.8222 22.6424 20.6208C23.7903 19.4194 25.2827 18.6985 27.0048 18.6985C28.7268 18.6985 30.2194 19.2992 31.3673 20.6208C32.5154 21.8222 33.2043 23.3841 33.2043 25.1862C33.2043 26.9884 32.6302 28.5502 31.3673 29.7517ZM27.0049 28.4302C27.8087 28.4302 28.4975 28.0697 29.0715 27.469C29.6454 26.8683 29.9899 26.0272 29.9899 25.1863C29.9899 24.3453 29.6454 23.5043 29.0715 22.9035C28.4975 22.3029 27.8087 21.9423 27.0049 21.9423C26.2013 21.9423 25.5125 22.3029 24.9385 22.9035C24.3646 23.5043 24.1349 24.3453 24.1349 25.1863C24.1349 26.0272 24.3646 26.8683 24.9385 27.469C25.5125 28.0697 26.2013 28.4302 27.0049 28.4302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3552 31.6741C39.7481 31.6741 38.6 31.1935 37.7964 30.2323V37.2006H34.467V18.9388H37.6815V20.3805C38.6 19.2992 39.7481 18.6985 41.2405 18.6985C41.9294 18.6985 42.6182 18.8186 43.3069 19.0589C43.9958 19.2992 44.5699 19.6596 45.1438 20.2604C45.7178 20.741 46.177 21.4619 46.5215 22.3028C46.8659 23.1438 46.9806 24.105 46.9806 25.1862C46.9806 27.2287 46.4067 28.7905 45.1438 29.992C44.1106 31.0733 42.8477 31.6741 41.3552 31.6741ZM40.6663 28.5503C41.5846 28.5503 42.2734 28.1899 42.9623 27.5892C43.5362 26.9884 43.8807 26.1475 43.8807 25.1863C43.8807 24.2251 43.5362 23.3841 42.9623 22.7835C42.3883 22.1826 41.5846 21.8223 40.6663 21.8223C39.7478 21.8223 39.0589 22.1826 38.485 22.7835C37.9109 23.3841 37.5665 24.2251 37.5665 25.1863C37.5665 26.1475 37.9109 26.8683 38.485 27.5892C39.0589 28.1899 39.8625 28.5503 40.6663 28.5503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2437 31.4335V18.9386H51.4581V31.4335H48.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5755 31.6741C57.1978 31.6741 55.8202 31.0733 54.6721 29.992C53.5241 28.7905 52.8352 27.2287 52.8352 25.1862C52.8352 23.7445 53.1797 22.5431 53.7537 21.5819C54.3278 20.6208 55.1314 19.8999 55.935 19.4194C56.7385 18.9388 57.657 18.6985 58.5755 18.6985C60.0679 18.6985 61.216 19.1791 62.1344 20.1402V18.9388H65.4637V31.4338H62.2492V29.992C61.3307 31.0733 60.0679 31.6741 58.5755 31.6741ZM59.2639 28.5503C60.1823 28.5503 60.871 28.1899 61.4451 27.5892C62.0191 26.9884 62.3635 26.1474 62.3635 25.1863C62.3635 24.2251 62.0191 23.5043 61.4451 22.7835C60.871 22.1826 60.1823 21.8223 59.2639 21.8223C58.3454 21.8223 57.6565 22.1826 56.9677 22.7835C56.3937 23.3841 56.0494 24.2251 56.0494 25.1863C56.0494 26.1474 56.3937 26.9884 56.9677 27.5892C57.5418 28.1899 58.3454 28.5503 59.2639 28.5503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.851 18.0982C50.4251 18.0982 50.7694 17.8579 51.1139 17.4973C51.4583 17.137 51.6879 16.6564 51.6879 16.1758C51.6879 15.5751 51.4583 15.2146 51.1139 14.8542C50.7694 14.4939 50.3102 14.2536 49.851 14.2536C49.3917 14.2536 48.9326 14.4939 48.5881 14.8542C48.2438 15.2146 48.1289 15.6952 48.1289 16.1758C48.1289 16.6564 48.2438 17.137 48.5881 17.4973C48.9326 17.8579 49.3917 18.0982 49.851 18.0982Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopiaLogo);
export default __webpack_public_path__ + "static/media/topiaLogo.12b85b5f33213a70d9604a55eeba511b.svg";
export { ForwardRef as ReactComponent };